import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  constructor(private spinner: NgxSpinnerService) {
   
   }

  showLoader() {
    this.spinner.show();
    // var oldSpinner =  document.getElementsByClassName('la-ball-scale-multiple')
    // var spinnerElement = document.createElement('img');
    // spinnerElement.src = '/assets/tarangplus/danaglPlay_loader.gif';
    // spinnerElement.setAttribute('class', 'spinner');
    // spinnerElement.setAttribute('alt', 'Loading...');

    
    // console.log(document.getElementsByClassName('la-ball-scale-multiple'))
    // // console.log(document.getElementsByTagName('ngx-spinner'))
    // if(oldSpinner && oldSpinner.length > 1){
    //  for(let i =0; i<oldSpinner.length;i++){
    //   oldSpinner[i].innerHTML = spinnerElement.outerHTML;
    //  }
    // }else if(oldSpinner.length == 1){
    //   document.getElementsByClassName('la-ball-scale-multiple')[0].innerHTML = spinnerElement.outerHTML;
    // }
    
    //




  }

  hideLoader() {
    this.spinner.hide();
  }
}
